import { ApiEndpoints } from '../constantes/ApiEndpoints';
import {
  SendOtpRequest,
  SendOtpResponse,
  ValidateOtpRequest,
  ValidateOtpResponse,
  ValidateResetPasswordOtpRequest,
  ValidateResetPasswordOtpResponse
} from '../_types/otp.types';
import { apiUserAccount } from '../../../services/api/ApiService';
import { getSchemaIdFromStorage } from '../../../utils/getSchemaIdFromStorage';
import { generateDeviceData } from './AccountService';


export const useOtpService = () => ({
  sendOtp: async (data: SendOtpRequest): Promise<SendOtpResponse> => {
    const schemaId = getSchemaIdFromStorage();
    
    const headers: Record<string, string> = {};
    if (data.captchaToken) {
      headers['X-Challenge-Verify'] = data.captchaToken;
      headers['X-Challenge-Host'] = process.env.REACT_APP_TURNSTILE_HOST || '';
    }
    
    return await apiUserAccount.post<SendOtpResponse>(
      `${ApiEndpoints.auth.requestOtpCode}?schemaId=${schemaId}`, 
      data,
      Object.keys(headers).length > 0 ? { headers } : undefined
    );
  },
  
  validateOtp: async (data: ValidateOtpRequest): Promise<ValidateOtpResponse> => {
    const schemaId = getSchemaIdFromStorage();
    
    const deviceData = await generateDeviceData();
    
    const headers: Record<string, string> = {};
    if (data.captchaToken) {
      headers['X-Challenge-Verify'] = data.captchaToken;
      headers['X-Challenge-Host'] = process.env.REACT_APP_TURNSTILE_HOST || '';
    }
    
    return await apiUserAccount.post<ValidateOtpResponse>(
      `${ApiEndpoints.auth.validateOtpCode}?schemaId=${schemaId}`, 
      {
        ...data,
        deviceData
      },
      Object.keys(headers).length > 0 ? { headers } : undefined
    );
  },
  
  validateOtpForgotPasswordCode: async (data: ValidateResetPasswordOtpRequest): Promise<ValidateResetPasswordOtpResponse> => {
    const schemaId = getSchemaIdFromStorage();

    return await apiUserAccount.post<ValidateResetPasswordOtpResponse>(`${ApiEndpoints.account.recoveryCheckCode}?schemaId=${schemaId}`, data)
  }
});
